import { render, staticRenderFns } from "./SceneEdit.vue?vue&type=template&id=2be469a4&scoped=true"
import script from "./SceneEdit.vue?vue&type=script&lang=js"
export * from "./SceneEdit.vue?vue&type=script&lang=js"
import style0 from "./SceneEdit.vue?vue&type=style&index=0&id=2be469a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be469a4",
  null
  
)

export default component.exports